'use client';

import { Input } from "@heroui/input";
import { SearchIcon } from "@/components/icons";
import { useRouter, useSearchParams } from "next/navigation";

export const SearchInput = () => {
  const router = useRouter();
  const searchParams = useSearchParams()
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const search = formData.get("search") as string;
    if (!search) return;
    router.push(`/search?q=${search}`);
  };

  const searchQuery = searchParams.get("q") || "";

  return <form onSubmit={onSubmit}>
      <Input
        name="search"
        aria-label="Пошук"
        defaultValue={searchQuery}
        classNames={{
          inputWrapper: "bg-default-100",
          input: "text-sm",
        }}
        labelPlacement="outside"
        placeholder="Пошук..."
        startContent={
          <SearchIcon className="text-base text-default-400 pointer-events-none flex-shrink-0" />
        }
        type="search"
      />
    </form>;
}